module.exports = __webpack_public_path__ + "img/thumbnail_Caracal_j_normal.c4d61c3f.png";